export default __webpack_public_path__ + "static/media/11-yawning-face_1f971.7936b9a7.png";